import type {
  IScheduledEmailContent,
  IScheduledEmailContentV2,
  IScheduledEmailCustomizations,
  IScheduledEmailCustomizationsV2,
} from '@/types/email.types';
import { isObject } from 'underscore';

export const isEmailTemplateV1 = (
  email: IScheduledEmailContent | IScheduledEmailContentV2 | undefined
): email is IScheduledEmailContent => {
  return isObject(email) && 'base' in email;
};

export const isEmailTemplateV2 = (
  email: IScheduledEmailContent | IScheduledEmailContentV2 | undefined
): email is IScheduledEmailContentV2 => {
  return isObject(email) && !!email.templateId;
};

export const isCustomEmailV2 = (
  email: IScheduledEmailCustomizations | IScheduledEmailCustomizationsV2 | undefined
): email is IScheduledEmailCustomizationsV2 => {
  return isObject(email) && 'v2' in email;
};
